import { useState, useEffect, useCallback } from 'react';
import { RTCTask } from 'core/models/rtc';
import { useVehicleRepository } from './useVehicleRepository';
import { Vehicle } from 'core/models/vehicle';
import { Project } from 'core/models/project';
import { Environment } from 'core/models/environment';
import { RTCCommandManager } from './RTC/RTCCommandManager';

export function useRTCAccept(vehicleId: Vehicle.Id, projectId: Project.Id, environmentId: Environment.Id) {
    const [manager, setManager] = useState<RTCCommandManager>();

    const repository = useVehicleRepository();
    useEffect(() => {
        const manager = new RTCCommandManager(repository, vehicleId, projectId, environmentId);
        setManager(manager);
        return () => manager.dispose();
    }, [environmentId, projectId, repository, vehicleId]);

    return useCallback((task: RTCTask, accepted: boolean) => {
        if (!manager) return;
        return manager.postRTCCommand(task, accepted);
    }, [manager]);
}
